import { Box, Button, Grid, useTheme } from "@mui/material";
import {
	CLIENT_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import {
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedSnackbar,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import { IResponse, IServerError } from "../../models/common";
import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	setSelectedActivityLogActions,
	setSelectedDrawerMenu,
	setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AdminClientRoutesComponent } from "../RoleBasedLeftMenu/routes/AdminClientRoutes";
import { ChequeSettingsService } from "../../services/ChequeSettingsService";
import { ClientRoutesComponent } from "../RoleBasedLeftMenu/routes/ClientRoutes";
import { IAppState } from "../../store/reducers";
import { IChequeSettings } from "../../models/ChequeSettings";
import { IGetListRequest } from "../../models";
import { PrimeDataGrid } from "../PrimeDataGrid";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { useNavigateToLogout } from "../../common/Common";

export interface IChequeSettingsList { }
const CLIENT_LIST_QUERY_KEY = "chequeSettings-list";

const useChequeSettingses = (
	clientId: string,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ["chequeSettings-list", params],
		queryFn: (data) => {

			return ChequeSettingsService.getChequeSettings(
				clientId,
				params,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});

export const ChequeSettingsList: React.FC<IChequeSettingsList> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const clientIdStore = useSelector((state: IAppState) => state.client.id);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();
	const { AdminClientRoutes } = AdminClientRoutesComponent();
	const { ClientRoutes } = ClientRoutesComponent();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "name",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const { id } = useSelector((state: IAppState) => state.accountant);
	const { isPending, data } = useChequeSettingses(
		clientIdStore,
		queryParams,
		navigateToLogout
	); //useQuery('accountants-list', AccountantService.getAccountantList, { refetchOnWindowFocus: false });
	const chequeSettingsList: any | null = data;

	const { message, componentState } = useSelector(
		(state: IAppState) => state.viewState
	);

	// const { accountantList } = useSelector(
	//   (state: IAppState) => state.accountant
	// );

	const [openDialog, setDialogOpen] = useState(false);
	const [selectedIds, setSelectedIds] = useState([]);
	const [statusValue, setStatusValue] = useState("");
	const [apiAction, setApiAction] = useState("");
	const [emptyList, setEmptyList] = useState(false);
	const [searchText, setSearchText] = useState({});
	const [zeroChequeSettings, setzeroChequeSettings] = useState(true);
	const [chequeSettingsListUpdatedItems, setChequeSettingsListUpdatedItems] =
		useState<any>(undefined);

	// for delete row
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [chequeSettingsId, setChequeSettingsId] = useState<any>(0);

	// Bulk Delete
	const [bulkDelete, setBulkDelete] = useState<boolean>(false);
	const [bulkChequeSettingsId, setBulkChequeSettingsId] = useState<any>({});
	const [bulkChequeSettingsDelete, setBulkChequeSettingsDelete] =
		useState<boolean>(false);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by: "name",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const onSearchButtonClicked = () => {
		setQueryParams(searchText);
		setzeroChequeSettings(false);
	};

	const onRowEditClicked = useCallback((params: IChequeSettings) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/settings/cheque/setup/${params.id}`;
		navigate(path);
	}, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const callAction = () => {
		if (apiAction === "delete") {
			alert(`Delete row with ID: ${selectedIds} has been clicked!`);
			// TODO api call for delete
		} else if (apiAction === "updateStatus") {
			alert(`action need to trigger : ${apiAction}`);
			// TODO api call for update status
		}
		setDialogOpen(false);
	};

	// For Delete Row
	const deleteChequeSettingsField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				chequeSettingsId: chequeSettingsId,
				navigateToLogout: navigateToLogout,
			};
			deleteChequeSettingsById(delPayload);
			setDialogOpen(false);
		}
	};

	const onRowDeleteClicked = useCallback((params: IChequeSettings) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setApiAction("delete");
		setChequeSettingsId(params.id);
	}, []);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteChequeSettingsById } =
		useMutation({
			mutationFn: ChequeSettingsService.delChequeSettings,
			onSuccess: (res: string | IServerError | IResponse | any) => {

				if (res) {
					// remove the cache of the Year fields since we just added a new field.
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong.",
						severity: res.status === false ? "error" : "success",
					});

					return queryClient.invalidateQueries({
						queryKey: [CLIENT_LIST_QUERY_KEY],
					});
				} else {
					setSnackbarData({
						open: true,
						message: "Something went wrong, try again later!",
						severity: "error",
					});
				}
			},
			onError: (err) => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setStatusValue(event.target.value as string);
		setApiAction("updateStatus");
		setDialogOpen(true);
	};

	// const onKeyFieldClickHandler = (clickedRow: any) => {
	// dispatch(setSelectedChequeSettings(clickedRow));
	// dispatch(setSelectedChequeSettingsName(clickedRow));
	// };

	//bulk delete

	const { isPending: isBulkDeleting, mutate: deleteBulkChequeSettingses } =
		useMutation({
			mutationFn: ChequeSettingsService.delBulkChequeSettingses,
			onSuccess: (res: any | string | IServerError | IResponse) => {
				if (typeof res === "object") {
					// remove the cache of the Year fields since we just added a new field.
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong.",
						severity: res.status === false ? "error" : "success",
					});

					setBulkChequeSettingsDelete(false);
					return queryClient.invalidateQueries({
						queryKey: [CLIENT_LIST_QUERY_KEY],
					});
				} else {
					setSnackbarData({
						open: true,
						message: "Something went wrong, try again later!",
						severity: "error",
					});
				}
				setBulkChequeSettingsDelete(false);
			},
			onError: (err: any) => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: err.message,
					severity: "error",
				});
				setBulkChequeSettingsDelete(false);
			},
		});

	// For Bulk Delete
	const deleteBulkChequeSettingsField = () => {
		if (bulkDelete) {
			setBulkDelete(false);
			let payload = {
				chequeSettingsIds: bulkChequeSettingsId,
				navigateToLogout: navigateToLogout,
			};
			deleteBulkChequeSettingses(payload);
			setDialogOpen(false);
		}
	};

	const onRowMultipleDeleteClicked = (params: any) => {

		let bulkDeletePayload = {
			chequeSettingsIds: { chequeSettingsIds: params },
		};
		setDialogOpen(true);
		setBulkDelete(true);
		setApiAction("delete");
		setBulkChequeSettingsId(bulkDeletePayload);
		setBulkChequeSettingsDelete(true);
	};

	const selectionToolbar = useCallback((selectedItems: any) => {
		setSelectedIds(selectedItems);

		if (selectedItems.length) {
			return (
				<Box sx={{ marginTop: theme.spacing(1) }}>
					<Button
						onClick={() => onRowMultipleDeleteClicked(selectedItems)}
						variant="contained"
						color="error"
					>
						Delete
					</Button>
				</Box>
			);
		}
		return (
			<Box sx={{ marginTop: theme.spacing(1) }}>
				<RouterLinkButton
					to="/settings/cheque/setup"
					text="Add Cheque Settings"
				/>
			</Box>
		);
	}, []);

	const upadtedChequeSettingsListItems = useMemo(() => {
		return (
			chequeSettingsList &&
			chequeSettingsList.items &&
			chequeSettingsList?.items.map((item: any) => ({
				...item,
				title: (
					<Link
						to={`/settings/cheque/setup/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
					>
						{item.title}
					</Link>
				),
			}))
		);
	}, [chequeSettingsList]);



	const expandedLabels = ["Settings", "Cheque"];
	const expandedChequeSettingsListOrSetupItem = "List"; // Special case for "List" under "ChequeSettings"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Cheque" &&
				item.label === expandedChequeSettingsListOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: isExpanded,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: CLIENT_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_chequeSettings_list.png";

	return chequeSettingsList &&
		chequeSettingsList.items &&
		chequeSettingsList.items.length === 0 &&
		zeroChequeSettings === true ? (
		<EmptyList
			showImage={true}
			imagePath={image}
			heading={`There's nothing! Add Cheque Settings to proceed`}
			content={`You can add ChequeSettings by directly clicking on add ChequeSettings button.`}
			testId={"chequeSettings-empty-list"}
			showAddButton={true}
			addButtonLabel={"Add Cheque Settings"}
			navigateToAdd={"/settings/cheque/setup"}
			showImportButton={false}
			showImportXmlButton={false}
		/>
	) : (
		<>
			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={
						bulkChequeSettingsDelete === true
							? deleteBulkChequeSettingsField
							: deleteChequeSettingsField
					}
					cancelActionHandler={onCloseHandler}
					testId="tax-profile-tab-confirmation-dialog"
				/>
				<PrimeDataGrid
					columns={chequeSettingsList ? chequeSettingsList.headerColumns : []}
					rows={
						chequeSettingsList && upadtedChequeSettingsListItems
							? upadtedChequeSettingsListItems
							: []
					}
					showIndexColumn={true}
					showChecboxColumn={isAdminUser === 400 ? true : false}
					showSettingColumn={true}
					onRowEditClicked={onRowEditClicked}
					onRowDeleteClicked={onRowDeleteClicked}
					isLoading={isPending || isDeleting || isBulkDeleting}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						chequeSettingsList && chequeSettingsList.total
							? chequeSettingsList.total
							: 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					selectionToolbar={selectionToolbar}
					selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
					searchFieldPlaceholder={"Search by ChequeSettings Name..."}
					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroChequeSettings(value)
					}
				/>
			</Grid>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
